/* globals window */
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { routerMiddleware, connectRouter } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import thunkMiddleware from 'redux-thunk';
import { all, fork } from 'redux-saga/effects';
import { adminReducer, adminSaga, USER_LOGOUT } from 'react-admin';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import settingsReducer from '../reducers/settingsReducer';
import scheduleReducer from '../reducers/scheduleReducer';
import notificationsReducer from '../reducers/notificationsReducer';
import unreadMessageReducer from '../reducers/unreadMessageReducer';

export default ({ authProvider, dataProvider, history }) => {
  const reducer = combineReducers({
    admin: adminReducer,
    settings: settingsReducer,
    schedule: scheduleReducer,
    notifications: notificationsReducer,
    unreadMessage: unreadMessageReducer,
    router: connectRouter(history),
  });
  const resettableAppReducer = (state, action) =>
    reducer(action.type !== USER_LOGOUT ? state : undefined, action);

  const saga = function* rootSaga() {
    yield all(
      [
        adminSaga(dataProvider, authProvider),
        // add your own sagas here
      ].map(fork),
    );
  };
  const sagaMiddleware = createSagaMiddleware();

  const composeEnhancers =
    (process.env.NODE_ENV === 'development' &&
      typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        trace: true,
        traceLimit: 25,
      })) ||
    compose;

  const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['admin', 'schedule'],
  };
  const persistedReducer = persistReducer(persistConfig, resettableAppReducer);

  const store = createStore(
    persistedReducer,
    {
      /* set your initial state here */
    },
    composeEnhancers(
      applyMiddleware(
        sagaMiddleware,
        thunkMiddleware,
        routerMiddleware(history),
      ),
    ),
  );
  sagaMiddleware.run(saga);
  return store;
};
